<template>
  <div class="product-box-copy">
    <component
      v-if="title"
      :is="titleTag"
      v-text="title"
      class="product-box-copy__title text-body-m text-heading-l-desktop"
    >
    </component>

    <div
      v-if="description"
      v-html="description"
      class="product-box-copy__description"
    />

    <div
      v-if="accordion.length > 0"
      class="product-box-copy__accordion"
    >
      <accordion-item
        v-for="accordionItem in accordion"
        :active="accordionItem.active"
        :key="accordionItem.title"
        :index="accordionItem.index"
        :toggle-index="toggleIndex"
        :multi-open="false"
        :group="index"
        :block-class="'product-box-copy'"
        :content="accordionItem.description ? true : false"
        @accordionToggle="handleAccordionToggle"
      >
        <template #title>
          {{ accordionItem.title }}
        </template>
        <template #content>
          <div class="product-box-copy__accordion-content-inner">
            <div
              class="text-body-s"
              v-html="accordionItem.description"
            />
          </div>
        </template>
      </accordion-item>
    </div>

    <div
      v-if="footer"
      v-html="footer"
      class="product-box-copy__footer text-body-s"
    />
  </div>
</template>

<script>

/**
 * Vue: Product box copy (product-copy-vue)
 * -----------------------------------------------------------------------------
 *
 */
import AccordionItem from '~async/accordion/accordion-item'

export default {
  name: 'ProductBoxCopy',

  components: {
    AccordionItem,
  },

  props: {
    blockClass: {
      type: String,
      default: '',
    },

    titleTag: {
      type: String,
      default: '',
    },

    index: {
      type: [Number, Boolean],
      default: false,
    },

    title: {
      type: String,
      default: '',
    },

    description: {
      type: String,
      default: '',
    },

    footer: {
      type: String,
      default: '',
    },

    accordion: {
      type: Array,
      default: () => [],
    },

    toggleIndex: {
      type: Object,
      default: () => {},
    },

  },

  data() {
    return {

    }
  },

  methods: {

    /**
     * Handles accordion item click
     * @param {Number} index - index of accordion item that was clicked
     * @param {Number} group - index of accordion group
     */
    handleAccordionToggle(index, group) {
      this.$emit('accordionToggle', {
        index,
        group,
      })
    },
  },
}
</script>

<style lang="scss">
@import './product-box-copy';
</style>

